import { api, type AnalyticsEventType } from './api';

type InteractionPayload = {
  itemId: string;
  eventType?: AnalyticsEventType;
  durationMs: number;
};

export function recordInteraction(payload: InteractionPayload): void {
  if (!payload.itemId) {
    return;
  }

  api.analytics
    .recordInteraction({
      itemId: payload.itemId,
      eventType: payload.eventType ?? 'view',
      durationMs: payload.durationMs,
    })
    .catch((err) => {
      // Fire-and-forget: log locally but never block the UI.
      console.warn('Analytics interaction failed', err);
    });
}






